export default __webpack_public_path__ + "static/media/endorsement-perpani-jabar.b9647c61.png";